import CustomerGroupQuery from './CustomerGroup';

export default CustomerGroupQuery;


// WEBPACK FOOTER //
// ./src/components/Query/CustomerGroup/index.ts